import CommonUtils from '@/resources/utils/common-utils';
import API from '@/config/api';


const member = {

    state: {

    },

    mutations: {

        getMemberLists(state, data) {
            data.url = API.member.getMemberLists;
            CommonUtils.GetRequest(data);
        },

        getProposalGuaranteeLists(state, data) {
          data.url = API.proposal.getProposalGuaranteeLists;
          CommonUtils.GetRequest(data);
        },

        getProposalGuaranteeList(state, data) {
          data.url = API.proposal.getProposalGuaranteeList;
          CommonUtils.GetRequest(data);
        },

        getProposalGuaranteeDetail(state, data) {
          data.url = API.proposal.getProposalGuaranteeDetail;
          CommonUtils.GetRequest(data);
        },

        postProposalGuaranteeDetail(state, data) {
          data.url = API.proposal.postProposalGuaranteeDetail;
          CommonUtils.PostRequest(data);
        },

        addProposalGuaranteeDetail(state, data) {
          data.url = API.proposal.addProposalGuaranteeDetail;
          CommonUtils.PostRequest(data);
        },

        delProposalGuaranteeDetail(state, data) {
          data.url = API.proposal.delProposalGuaranteeDetail;
          CommonUtils.GetRequest(data);
        },

        getProposalProductList(state, data) {
          data.url = API.proposal.getProposalProductList;
          CommonUtils.GetRequest(data);
        },
        getProductInsuranceClassList(state, data) {
          data.url = API.proposal.getProductInsuranceClassList;
          CommonUtils.PostRequest(data);
        },
        addProposalProduct(state, data) {
          data.url = API.proposal.addProposalProduct;
          CommonUtils.PostRequest(data);
        },
        copyProposalProduct(state, data) {
          data.url = API.proposal.copyProposalProduct;
          CommonUtils.PostRequest(data);
        },

        updateProposalProduct(state, data) {
          data.url = API.proposal.updateProposalProduct;
          CommonUtils.PostRequest(data);
        },

        getProposalCategoryInfo(state, data) {
          data.url = API.proposal.getProposalCategoryInfo;
          CommonUtils.GetRequest(data);
        },

        importFromExcel(state, data) {
          data.url = API.proposal.importFromExcel;
          CommonUtils.PostRequest(data);
        },

        saveRate(state, data) {
          data.url = API.proposal.saveRate;
          CommonUtils.PostRequest(data);
        },

        getRateInfo(state, data) {
          data.url = API.proposal.getRateInfo;
          CommonUtils.GetRequest(data);
        },

        // changeStatus(state, data) {
        //   data.url = API.proposal.changeStatus;
        //   CommonUtils.PostRequest(data);
        // },

        setProposalStatus(state, data) {
          data.url = API.proposal.setProposalStatus;
          CommonUtils.PostRequest(data);
        },
        // 获取储蓄列表
        getSavingsList(state, data){
          data.url = API.proposal.getSavingsList
          CommonUtils.GetRequest(data)
        },
        // 更新储蓄列表状态
        updateSavingStatus(state, data){
          data.url = API.proposal.updateSavingStatus
          CommonUtils.PostRequest(data)
        },
        // 获取保险公司列表
        insuranceType(state, data){
          data.url = API.proposal.insuranceList
          CommonUtils.GetRequest(data)
        },
        // 添加储蓄产品列表数据
        addSavings(state, data){
          data.url = API.proposal.addSavings
          CommonUtils.PostRequest(data)
        },
        // 获取储蓄产品详情
        savingsDetail(state, data){
          data.url = API.proposal.savingsDetail
          CommonUtils.GetRequest(data)
        },
        // 储蓄产品详情编辑更新
        updateSavingsDetail(state, data){
          data.url = API.proposal.updateSavingsDetail
          CommonUtils.PostRequest(data)
        },
        // 获取产品费率管理详情
        rateManagerDetail(state, data){
          data.url = API.proposal.rateManagerDetail
          CommonUtils.GetRequest(data)
        },
        // 保存费率保存
        saveRateInfo(state, data){
          data.url = API.proposal.saveRateInfo
          CommonUtils.PostRequest(data)
        },
        // 保存现价保存
        saveCashInfo(state, data){
          data.url = API.proposal.saveCashInfo
          CommonUtils.PostRequest(data)
        },
        // 理财规划设置信息
        financialInfo(state, data) {
          data.url = API.proposal.financialInfo
          CommonUtils.GetRequest(data)
        },
        // 市场环境信息
        financialMarketInfo(state, data) {
          data.url = API.proposal.financialMarketInfo
          CommonUtils.GetRequest(data)
        },
        // 保存市场环境信息
        saveFinancialMarketInfo(state, data) {
          data.url = API.proposal.saveFinancialMarketInfo
          CommonUtils.PostRequest(data)
        },
        // 社平工资信息
        financialWageAvgInfo(state, data) {
          data.url = API.proposal.financialWageAvgInfo
          CommonUtils.GetRequest(data)
        },
        // 保存社平工资信息
        saveFinancialWageAvgInfo(state, data) {
          data.url = API.proposal.saveFinancialWageAvgInfo
          CommonUtils.PostRequest(data)
        },
        // 编辑社平工资
        editFinancialWageAvgInfo(state, data) {
          data.url = API.proposal.editFinancialWageAvgInfo
          CommonUtils.PostRequest(data)
        },
        // 国家/地区经济信息
        financialRegionalEconomyInfo(state, data) {
          data.url = API.proposal.financialRegionalEconomyInfo
          CommonUtils.GetRequest(data)
        },
        // 新增国家/地区经济信息
        addFinancialRegionalEconomyInfo(state, data) {
          data.url = API.proposal.addFinancialRegionalEconomyInfo
          CommonUtils.PostRequest(data)
        },
        // 编辑国家/地区经济信息
        editFinancialRegionalEconomyInfo(state, data) {
          data.url = API.proposal.editFinancialRegionalEconomyInfo
          CommonUtils.PostRequest(data)
        },
        // 教育费用信息
        financialEduExpensesInfo(state, data) {
          data.url = API.proposal.financialEduExpensesInfo
          CommonUtils.GetRequest(data)
        },
        // 新增教育费用信息
        addFinancialEduExpensesInfo(state, data) {
          data.url = API.proposal.addFinancialEduExpensesInfo
          CommonUtils.PostRequest(data)
        },
        // 编辑教育费用信息
        editFinancialEduExpensesInfo(state, data) {
          data.url = API.proposal.editFinancialEduExpensesInfo
          CommonUtils.PostRequest(data)
        },
        getProposalTemplatePageList(state, data) {
          data.url = API.proposal.getProposalTemplatePageList;
          CommonUtils.GetRequest(data);
        },
        getProposalTagList(state, data) {
          data.url = API.proposal.getProposalTagList;
          CommonUtils.GetRequest(data);
        },
        addProposalFamilyTag(state, data) {
          data.url = API.proposal.addProposalFamilyTag
          CommonUtils.PostRequest(data)
        },
        editProposalFamilyTag(state, data) {
          data.url = API.proposal.editProposalFamilyTag
          CommonUtils.PostRequest(data)
        },
        addProposalTemplate(state, data) {
          data.url = API.proposal.addProposalTemplate
          CommonUtils.PostRequest(data)
        },
        deleteProposalFamilyTag(state, data) {
          data.url = API.proposal.deleteProposalFamilyTag
          CommonUtils.PostRequest(data)
        },
        changeStatusProposalTemplate(state, data) {
          data.url = API.proposal.changeStatusProposalTemplate
          CommonUtils.PostRequest(data)
        },
        getProposalTemplateDetail(state, data) {
          data.url = API.proposal.getProposalTemplateDetail;
          CommonUtils.GetRequest(data);
        },
        editProposalTemplate(state, data) {
          data.url = API.proposal.editProposalTemplate
          CommonUtils.PostRequest(data)
        },
        getDiseaseList(state, data) {
          data.url = API.proposal.getDiseaseList;
          CommonUtils.GetRequest(data);
        },
        cancelBindProduct(state, data) {
          data.url = API.proposal.cancelBindProduct
          CommonUtils.PostRequest(data)
        },
        bindProduct(state, data) {
          data.url = API.proposal.bindProduct
          CommonUtils.PostRequest(data)
        },
        getTemplateDetail(state, data) {
          data.url = API.proposal.getTemplateDetail;
          CommonUtils.GetRequest(data);
        },
        updateTempName(state, data) {
          data.url = API.proposal.updateTempName
          CommonUtils.PostRequest(data)
        },
        saveClassOneDisease(state, data) {
          data.url = API.proposal.saveClassOneDisease
          CommonUtils.PostRequest(data)
        },
        getDiseaseBindInsuranceList(state, data) {
          data.url = API.proposal.getDiseaseBindInsuranceList;
          CommonUtils.GetRequest(data);
        },
        deleteOneDiseaseSeries(state, data) {
          data.url = API.proposal.deleteOneDiseaseSeries
          CommonUtils.PostRequest(data)
        },
        deleteDiseaseTemplate(state, data) {
          data.url = API.proposal.deleteDiseaseTemplate
          CommonUtils.PostRequest(data)
        },
        diseaseUpload(state, data) {
          data.url = API.proposal.diseaseUpload
          CommonUtils.PostRequest(data);
        },
        getOneLevelDisease(state, data) {
          data.url = API.proposal.getOneLevelDisease;
          CommonUtils.GetRequest(data);
        },
    }
    
};

export default member;



// WEBPACK FOOTER //
// ./src/store/modules/proposal.js